// extracted by mini-css-extract-plugin
export default {"mCard":"En-z","image":"Fn-z","imageNoBackground":"Gn-z","imageHasCategory":"Hn-z","fullWidth":"In-z"};